<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="10" style="padding:0.5px">
        <v-stepper v-model="e1">
          <v-stepper-header>
            <template v-for="n in steps">
              <v-stepper-step :key="`${n}-step`" :complete="e1 > n" :step="n" editable>
                Step {{ n }}
              </v-stepper-step>

              <v-divider v-if="n !== steps" :key="n"></v-divider>
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content v-for="n in steps" :key="`${n}-content`" :step="n">
              <v-card v-if="n === 1" elevation="0" class="mb-12">
                <v-card-title>
                  Enter Record Open ID
                </v-card-title>
                <v-card-text>
                  <v-row class="d-block d-md-flex">
                    <v-col sm="" md="12">
                      <v-switch v-model="importRecord.existUser" inset label="Client Already Exist"></v-switch>
                    </v-col>
                    <v-col md="4" v-if="importRecord.existUser" >
                      <v-text-field v-model="importRecord.selected_user.client_id" v-if="importRecord.existUser" label="Client ID" placeholder="Client ID" outlined></v-text-field>
                    </v-col>
                    <v-col md="4">
                      <v-text-field v-model="importRecord.open_id" label="Open ID" placeholder="oLRyZ1OJbTadeMfIgKkH5hiEc57I" outlined></v-text-field>
                    </v-col>
                    <v-col v-if="importRecord.existUser" md="12" >
                      <v-card>
                        <v-card-text>
                          <v-text-field v-model="importRecord.search" append-icon="fas fa-search" label="Search" outlined single-line hide-details></v-text-field>
                          <v-data-table
                            :headers="importRecord.user_header"
                            :items="users"
                            :items-per-page="5"
                            class="elevation-1"
                          >
                            <template v-slot:item.dob="{ item }">
                              {{new Date(item.dob).getFullYear() + '-' + (new Date(item.dob).getMonth() + 1) + '-' + new Date(item.dob).getDate()}}
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col md="4" v-if="!importRecord.existUser">
                      <v-text-field v-model="importRecord.internal.MemberGTLCode" type="number" label="MemberGTLCode" placeholder="30001027" outlined></v-text-field>
                    </v-col>
                    <v-col md="4" v-if="!importRecord.existUser">
                      <v-text-field v-model="importRecord.internal.MemberEmailID" label="MemberEmailID" placeholder="1234567890@qq.com" outlined></v-text-field>
                    </v-col>
                    <v-col md="4" offset-md="4" v-if="!importRecord.existUser">
                      <v-text-field v-model="importRecord.internal.FamilyGTLCode" type="number" label="FamilyGTLCode" placeholder="60001044" outlined></v-text-field>
                    </v-col>
                    <v-col md="4" v-if="!importRecord.existUser">
                      <v-text-field v-model="importRecord.internal.MemberWIXID" label="MemberWIXID" placeholder="99342247-5e8d-4acd-8f1f-22bfdb4736d7" outlined></v-text-field>
                    </v-col>
                    <v-col md="4" offset-md="4" v-if="!importRecord.existUser">
                      <v-text-field v-model="importRecord.internal.AgentGTLCode" type="number" label="AgentGTLCode" placeholder="20001008" outlined></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-card v-if="n === 2" elevation="0" class="mb-12" >
                <v-card-title>
                  Enter Client Basic Information and Internal
                </v-card-title>
                <v-card-text>
                  <div>
                    <v-row class="d-block d-md-flex">
                      <v-col md="4">
                        <v-text-field v-model="importRecord.additional_information.display_name" label="Display Name" placeholder="陳大文" outlined></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field v-model="importRecord.additional_information.first_name" label="First Name" placeholder="陳" outlined></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field v-model="importRecord.additional_information.last_name" label="Last Name" placeholder="大文" outlined></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field v-model="importRecord.additional_information.contact_email" label="Email" placeholder="chantaiman@gmail.com" outlined></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field v-model="importRecord.additional_information.mobile_number" label="Mobile Number" placeholder="+86 14216584753" outlined></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field v-model="importRecord.additional_information.wechatID" label="WechatID" placeholder="chantaiman13" outlined></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-select v-model="importRecord.additional_information.gender" label="Gender" :items="importRecord.gender" placeholder="M" outlined></v-select>
                      </v-col>
                      <v-col md="4">
                        <v-text-field v-model="importRecord.additional_information.dob" label="DOB" placeholder="1982-12-03" outlined></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field v-model="importRecord.additional_information.weight" type="number" label="Weight" placeholder="52.3" outlined></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field v-model="importRecord.additional_information.nationality" label="Nationality" placeholder="中國大陸" outlined></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field v-model="importRecord.additional_information.race" label="Race" placeholder="東亞人" outlined></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field v-model="importRecord.additional_information.address" label="Address" placeholder="香港尖沙咀北京道1號12樓" outlined></v-text-field>
                      </v-col>
                      <v-col md="4" offset-md="4">
                        <v-text-field v-model="importRecord.additional_information.display_lang" label="Display Language" placeholder="簡體中文" outlined></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </v-card>
              <v-card v-if="n === 3" elevation="0" class="mb-12">
                <v-card-title>
                  Enter Client Report Detail
                </v-card-title>
                <v-card-text>
                  <v-row class="d-block d-md-flex">
                    <v-col md="12" >
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                          <tr>
                            <th class="text-left">Report Name</th>
                            <th class="text-left">SalesGTLCode</th>
                            <th class="text-left">Edit</th>
                            <th class="text-left">Delete</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, index) in importRecord.report" :key="item.name">
                            <td>{{ item.reportName }}</td>
                            <td>{{ item.salesGTLCode }}</td>
                            <td><v-icon small>far fa-edit</v-icon></td>
                            <td><v-icon small @click="deleteReport(index)">far fa-trash-alt</v-icon></td>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                    <v-col md="4">
                      <v-btn color="primary" outlined @click="$store.commit('setNewReportDialogStatus', true)">
                        <v-icon left>far fa-plus-square</v-icon>
                        Add New Report
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <div style="margin: 0 auto;display: table;">
                <v-btn color="primary" v-if="e1 !== 3" @click="nextStep(n)">Continue</v-btn>
                <v-btn color="primary" v-else @click="submit()">Submit</v-btn>
                <v-btn text v-if="e1 !== 1"  @click="--e1">Cancel</v-btn>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
    <newReportDialog/>
  </v-container>
</template>

<script>
import newReportDialog from '../../components/dialog/newReportDialog/index.vue'
export default {
  name: 'index',
  data: () => ({
    e1: 1,
    steps: 3,
    importRecord: {}
  }),
  components: {
    newReportDialog
  },
  created () {
    this.importRecord = this.$store.state.importRecord
    this.$apis.readAdditionalInformation().then(res => {
      this.importRecord.users = res.data.data
    })
  },
  computed: {
    users () {
      return this.importRecord.users.filter(item =>
        item.display_name.includes(this.importRecord.search) ||
        item.display_lang.includes(this.importRecord.search) ||
        item.first_name.includes(this.importRecord.search) ||
        item.last_name.includes(this.importRecord.search) ||
        item.wechatID.includes(this.importRecord.search) ||
        item.mobile_number.includes(this.importRecord.search) ||
        item.contact_email.includes(this.importRecord.search) ||
        item.address.includes(this.importRecord.search) ||
        item.dob.includes(this.importRecord.search) ||
        item.gender.includes(this.importRecord.search) ||
        item.nationality.includes(this.importRecord.search) ||
        item.race.includes(this.importRecord.search) ||
        item.weight.toString().includes(this.importRecord.search) ||
        item.display_lang.includes(this.importRecord.search) ||
        this.importRecord.search === ''
      )
    }
  },
  watch: {
    steps (val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    }
  },
  methods: {
    deleteReport (index) {
      this.importRecord.report.splice(index, 1)
    },
    submit () {
      this.$store.commit('setLoadingState', true)
      if (this.importRecord.existUser) {
        this.importRecord.report.forEach(report => {
          this.$apis.createEssential({
            open_id: this.importRecord.open_id,
            client_id: this.importRecord.selected_user.client_id,
            report_name: report.reportName,
            report: report.report,
            SalesGTLCode: report.salesGTLCode
          })
        })
        this.$apis.createImportRecords({
          open_id: this.importRecord.open_id,
          client_id: this.importRecord.selected_user.client_id,
          total_report: this.importRecord.report.length,
          counter: '0',
          last_open_date: (new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()).toString()
        })
      } else {
        this.$apis.createAdditionalInformation(this.importRecord.additional_information).then(res => {
          this.importRecord.internal.client_id = res.data.client_id
          this.$apis.createInternalIds(this.importRecord.internal).then(res => {
            this.importRecord.report.forEach(report => {
              this.$apis.createEssential({
                open_id: this.importRecord.open_id,
                client_id: this.importRecord.internal.client_id,
                report_name: report.reportName,
                report: report.report,
                SalesGTLCode: report.salesGTLCode
              })
            })
            this.$apis.createImportRecords({
              open_id: this.importRecord.open_id,
              display_name: this.importRecord.additional_information.display_name,
              display_language: this.importRecord.additional_information.display_lang,
              MemberGTLCode: this.importRecord.internal.MemberGTLCode,
              AgentGTLcode: this.importRecord.internal.AgentGTLCode,
              total_report: this.importRecord.report.length,
              counter: '0',
              last_open_date: (new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()).toString()
            })
          })
        })
      }
      this.importRecord.report = []
      this.$store.commit('setLoadingState', false)
      this.$store.commit('reSetNewReportDialog')
      this.$store.commit('setSnackBar', {
        icon: 'far fa-check-square',
        color: 'success',
        message: 'Record Saved',
        status: true
      })
      this.e1 = 1
    },
    nextStep (n) {
      if (n === this.steps) {
        this.e1 = 1
      } else if (this.importRecord.existUser) {
        if (this.importRecord.selected_user.client_id !== '' && this.importRecord.open_id !== '') {
          this.importRecord.selected_user = this.importRecord.users.find(item => item.client_id === this.importRecord.selected_user.client_id)
          this.$apis.readInternalIds().then(res => {
            this.importRecord.selected_internal = res.data.data.find(item => item.client_id === this.importRecord.selected_user.client_id)
          })
          this.e1 = 3
        } else {
          this.$store.commit('setSnackBar', {
            status: true,
            color: 'error',
            icon: 'fas fa-exclamation-triangle',
            message: 'Please fill in all field'
          })
        }
      } else {
        if (this.e1 === 1) {
          if (!this.importRecord.existUser && this.importRecord.internal.MemberGTLCode !== '' && this.importRecord.internal.FamilyGTLCode !== '' && this.importRecord.internal.AgentGTLCode !== '' && this.importRecord.internal.MemberWIXID !== '' && this.importRecord.internal.MemberEmailID !== '') {
            this.e1 = n + 1
          } else {
            this.$store.commit('setSnackBar', {
              status: true,
              color: 'error',
              icon: 'fas fa-exclamation-triangle',
              message: 'Please fill in all field'
            })
          }
        } else if (this.e1 === 2) {
          this.e1 = n + 1
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
